import {useState} from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import {Box} from "@mui/material"
import ImageCarousel from "./ImageCarousel.tsx"  // ✅ Import the carousel

const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL

interface ImageGalleryProps {
    images: string[]
}

const ImageGallery = ({images}: ImageGalleryProps) => {
    const [imageList, setImageList] = useState<string[]>([]);
    const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);

    const handleImageClick = (index: number) => {
        const fullUrls = images.map((img) =>
            img.startsWith("/") ? img : `${VITE_API_BASE_URL}/${img}`
        );
        setImageList(fullUrls);
        setCurrentImageIndex(index);
    };

    const handleClose = () => {
        setImageList([]);
        setCurrentImageIndex(0);
    };

    const handlePrev = () => {
        setCurrentImageIndex((prev) =>
            prev === 0 ? imageList.length - 1 : prev - 1
        );
    };

    const handleNext = () => {
        setCurrentImageIndex((prev) =>
            prev === imageList.length - 1 ? 0 : prev + 1
        );
    };

    const settings = {
        dots: true,
        infinite: images.length > 1,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
    };

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: {xs: "100%", md: "630px"},
                margin: "auto",
            }}
        >
            <Slider {...settings} key={images.length}>
                {images.map((image, index) => (
                    <Box
                        key={index}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            overflow: "hidden",
                            borderRadius: "8px",
                            backgroundColor: "#f0f0f0",
                            cursor: "pointer",
                        }}
                        onClick={() => handleImageClick(index)}
                    >
                        <img
                            src={`${VITE_API_BASE_URL}/${image}`}
                            loading="lazy"
                            alt={`Bild ${index + 1}`}
                            style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                            }}
                        />
                    </Box>
                ))}
            </Slider>

            <ImageCarousel
                imageList={imageList}
                currentImageIndex={currentImageIndex}
                handleClose={handleClose}
                handlePrev={handlePrev}
                handleNext={handleNext}
            />
        </Box>
    );
};

export default ImageGallery;
